/**
 * @module SLIDER
 * @description slides slides in a slider. Currently only supports one slider per page
 */
var SLIDER=(function(my){
  var intervalID = null;
  my.init=function() {
    if (qsa(".slider").length == 0){ //no slider
      return;
    }

    qs(".counters").setAttribute("data-total", qsa(".slide").length);
    qs(".counters").setAttribute("style", `--slide-count: ${qsa(".slide").length}`);
    if (qsa(".slide").length <= 1) { //only one slide then no click listener or timer
      return;
    }

    qsa(".slide").forEach(testimonial=>testimonial.addEventListener("transitionend", evt=>{
      evt.target.removeClass("in,out");
    }));
    qs(".counters").addEventListener("click", evt=>{//figure out which counter depening on where the click happened
      let style = getComputedStyle(evt.target); 
      let size = style.getPropertyValue("--size");
      let fsize = style.getPropertyValue("font-size");
      if (size.indexOf("px")<0 && size.indexOf("em")>0) {
        size = parseInt(size) * parseInt(fsize);
      } else if (size.indexOf("px")>0) {
        size = parseInt(size);
      } else {
        size = 32;
      }
      if (!size) {return;}
      clearInterval(intervalID);
      slideTo(Math.ceil(evt.offsetX/size) - 1);
      intervalID = setInterval(slideBy, 10000, 1); 
    });

    intervalID = setInterval(slideBy, 10000, 1); 
  };

  var slideBy = function(delta) {
    let slides = qsa(".slide"),
        current = qs(".slide.showing");
    if (slides.length <= 1) {return;}
    if (!current) {return;}
    let currentIndex = Array.from(slides).indexOf(current),
        targetIndex = ((currentIndex+delta) % slides.length + slides.length) % slides.length;
    slideTo(targetIndex);
  }

  var slideTo = function(index) {
    let slides = qsa(".slide"),
        current = qs(".slide.showing");
    if (slides.length <= 1) {return;}
    if (!current) {return;}
    let slide = slides[index];
    if (!slide) {return;}
    current.toggleClass("showing,out");
    slide.toggleClass("showing,in");

    let counters = qs(".slider .counters"),
        total = counters.getAttribute('data-total');
    counters.setAttribute("data-current", index + 1);
    counters.setAttribute("aria-label", `${index + 1} of ${total}`);
  }

  return my;
}(SLIDER || {}))